// Module
var code = "<div class=\"sidebar-container\" ng-transclude ng-class=\"{ 'collapsible': collapsible }\"></div> ";
// Exports
module.exports = code;